// extracted by mini-css-extract-plugin
module.exports = {"card-decoration":"common-card_card-decoration__vJyHY","primary-head":"common-card_primary-head__y5Wl3","primary-content-spread":"common-card_primary-content-spread__q3KeI"};